module.exports = __webpack_public_path__ + "img/new_logo_header.32140a95.svg";